import { render, staticRenderFns } from "./DialogBatchItemEdit.vue?vue&type=template&id=2bb9fa48"
import script from "./DialogBatchItemEdit.vue?vue&type=script&lang=js"
export * from "./DialogBatchItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports